export default "__VITE_ASSET__C2_xmh9B__"